<!--
  @author:chen.hao
  @time:2018/11/8
  @disc:联想查询选择框
  type:
    org(经营组织)
    product(商品)
    customer(客户)
    allMember:(所有客户包含子账户)
    account(主子账号)
    childCustomer (子账户)
    searchSonAccount (通过主账号查询子账号)
    unsetpro(未设置分类商品)
    protocol(协议)
    activity(活动)
    robot(机器人)
    policyTemplate(政策模板)
    adminUser(后台用户)
    user(用户一卡通)
    chemical(化工品)
    jointCustomer(联合客户)
    takeOrder(提货单)
    customOrg(搜客户)
    tagOrg(搜标签)
    notCustomOrg(搜不包含客户)
    tagBreach(违约标签)
    marketModel(订货会模板)
    unionCustom(联合客户主账户)
    childUnionCustom(联合客户子账户)
    relatedCustomer(联合客户关联客户)
    role(角色)
    area(负责区域)
    oneCardMove(一卡通（移交协议）)
    protocolMove(协议（移交协议）)
    customMove(客户（移交协议）)
    customMoveAppoint(指定客户（移交协议）)
    customPolicy(客户（政策协议）)
    noIncludeFreight (查询⾮虚拟提货区域)
    orgIdsCustomer(查询经营组织下的客户)
  valueField:最终取值字段null返回对象，id,name返回对应字段
  extraParams:查询用额外参数
 -->

<template>
  <el-select v-bind="$attrs"
             v-on="$listeners"
             v-model="currentValue"
             filterable
             remote
             reserve-keyword
             :remote-method="remoteMethod"
             :loading="loading"
             value-key="id"
             @change="handleChange">
    <el-option v-for="item in showArr"
               :key="item.id"
               :label="extraLabel ? `${item.name} (${item[extraLabel]})` : item.name"
               :value="valueField?item[valueField]:item">
    </el-option>
    <div v-if="dataArr.length > 50"
         class="search-keyword">
      <span>只显示前50条结果，请完善搜索关键字</span>
    </div>
  </el-select>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  name: 'searchSelect',
  props: {
    type: {
      required: true
    },
    value: {},
    valueField: {},
    extraParams: {},
    extraLabel: '',
    initalOption: {
      default: () => {
        return ''
      }
    }
  },
  data () {
    return {
      loading: false,
      dataArr: [],
      typeMap: {
        customer: 1,
        product: 2,
        org: 3,
        protocol: 4,
        activity: 5,
        robot: 6,
        policyTemplate: 7,
        adminUser: 8,
        chemical: 9,
        account: 10,
        searchSonAccount: 11,
        searchSonAccount2: 111,
        jointCustomer: 10,
        takeOrder: 12,
        marketModel: 13,
        unionCustom: 14,
        childUnionCustom: 15,
        role: 16,
        area: 17,
        customPolicy: 181,
        relatedCustomer: 18,
        makretWillCustomer: 188, // 营销客户
        taxInvoiceCustomer: 19 // 税务开票查询客户
      },
      currentValue: []
    }
  },
  computed: {
    showArr () {
      return this.dataArr.slice(0, 50)
    },
    isMultiple () {
      return this.$attrs.multiple === '' || this.$attrs.multiple
    }
  },
  methods: {
    ...mapActions(['getNameInfo', 'searchJointCustomer', 'searchProducts', 'ydkSearchProducts',
      'searchChemical', 'getModelMarketReport', 'getProductMaintainList', 'loadCraneOilTankList',
      'searchChildCustomer', 'searchUser', 'searchCard', 'searchAccount',
      'searchSonAccount', 'searchSonAccount2', 'getCustomBreachOrder', 'getTagBreachOrder',
      'tagNameBreachOrder', 'getNotCustomBreachOrder', 'searchTakeOrder',
      'searchCardProtocol', 'searchProtocolProtocol', 'searchCustomProtocol', 'getProtocols',
      'searchCustomAppointProtocol', 'memberNameFuzzyQuery', 'searchNoIncludeFreight', 'adjustAccountYearOrBatch', 'getUsePolicyPage', 'getOrgIdsCustomer']),
    handleChange (val) {
      // console.log('xsp-------val===' + JSON.stringify(val) + '-------' + JSON.stringify(this.currentValue))
      this.$emit('changeValue', this.currentValue)
      if (!this.isMultiple) {
        if (this.valueField) {
          const obj = this.$lodash.find(this.dataArr, { id: this.currentValue })
          this.dataArr = obj ? [obj] : []
        } else {
          this.dataArr = this.currentValue ? [this.currentValue] : []
        }
      }
    },
    remoteMethod (query) {
      if (query !== '') {
        this.loading = true
        if (this.type === 'unsetpro') {
          this.searchProducts({ itemName: query }).then(res => {
            this.dataArr = res.map(item => {
              return {
                id: item.itemId,
                name: item.itemName,
                shortName: item.itemShortName,
                code: item.itemCode,
                proUnit: item.sellUnit
              }
            })
            this.loading = false
          })
        } else if (this.type === 'ydkProduct') {
          this.ydkSearchProducts({ relationName: query }).then(res => {
            this.dataArr = res.map(item => {
              return {
                id: item.itemCode,
                code: item.itemCode,
                name: item.itemName
              }
            })
            this.loading = false
          })
        } else if (this.type === 'storageCapacityPro') {
          this.getProductMaintainList({ productName: query }).then(res => {
            this.dataArr = res.map(item => {
              return {
                id: item.itemId,
                name: item.itemName,
                shortName: item.itemShortName,
                code: item.itemCode,
                proUnit: item.sellUnit
              }
            })
            this.loading = false
          })
        } else if (this.type === 'craneOilTank') {
          this.loadCraneOilTankList({ oilTankCode: query }).then(res => {
            this.dataArr = res.map(item =>
              ({
                id: item,
                code: item,
                name: item
              })
            )
            this.loading = false
          })
        } else if (this.type === 'user') {
          this.searchUser({ cardSolution: query }).then(res => {
            this.dataArr = res.map(item => {
              return {
                id: item.id,
                name: item.cartoonNumber,
                email: item.eMail,
                phone: item.phone,
                qq: item.qq,
                realName: item.name
              }
            })
            this.dataArr = this.dataArr.slice(0, 10)
            this.loading = false
          })
        } else if (this.type === 'card') {
          if (query.length === 10) {
            this.searchCard({ cardSolution: query }).then(res => {
              this.dataArr = res && res.map(item => {
                return {
                  id: item.cardSolution,
                  name: item.cardSolution,
                  realName: item.realName
                }
              })
              this.loading = false
            })
          } else {
            this.loading = false
          }
        } else if (this.type === 'chemical') {
          this.searchChemical({ itemName: query }).then(res => {
            this.dataArr = res.map(item => {
              return {
                id: item.itemId,
                name: item.itemName,
                shortName: item.itemShortName,
                code: item.itemCode,
                proUnit: item.sellUnit
              }
            })
            this.loading = false
          })
        } else if (this.type === 'account') {
          this.searchAccount({ condition: query, ...this.extraParams }).then(res => {
            this.dataArr = res.map(item => {
              return {
                id: item.accountId,
                customerName: item.customerName,
                name: item.userName,
                phone: item.phone
              }
            })
            this.loading = false
          })
        } else if (this.type === 'takeOrder') {
          this.searchTakeOrder({ takeOrderNo: query, ...this.extraParams }).then(res => {
            this.dataArr = res.map(item => {
              return {
                id: item.takeOrderNo,
                name: item.takeOrderNo,
                idCardNum: item.idCardNum,
                driverName: item.driverName,
                phoneNum: item.phoneNum,
                plateNum: item.plateNum,
                returnTakeNum: item.returnTakeNum,
                takeNum: item.takeNum,
                takeOrderNo: item.takeOrderNo
              }
            })
            this.loading = false
          })
        } else if (this.type === 'allMember') {
          this.memberNameFuzzyQuery({ memberName: query, ...this.extraParams }).then(res => {
            this.dataArr = res.map(item => {
              return {
                id: item.accountId,
                name: item.memberName
              }
            })
            this.loading = false
          })
        } else if (this.type === 'searchSonAccount') {
          this.searchSonAccount({ ...this.extraParams }).then(res => {
            this.dataArr = res.map(item => {
              return {
                id: item.id,
                name: item.username
              }
            })
            this.loading = false
          })
        } else if (this.type === 'searchSonAccount2') {
          this.searchSonAccount2({ ...this.extraParams, userName: query }).then(res => {
            this.dataArr = res.map(item => {
              return {
                id: item.id,
                name: item.username
              }
            })
            this.loading = false
          })
        } else if (this.type === 'jointCustomer') {
          this.searchJointCustomer({ name: query, ...this.extraParams }).then(res => {
            this.dataArr = res.map(item => {
              return {
                id: item.unionCode,
                name: item.unionRelevanceDTOS.map(item => { return item.memberName }).join(',')
              }
            })
            this.loading = false
          })
        } else if (this.type === 'childCustomer') {
          const params = {
            username: query,
            ...this.extraParams
          }
          this.searchChildCustomer(params).then(res => {
            this.dataArr = res.map(item => {
              return {
                id: item.childAccountId,
                name: item.username,
                code: item.itemCode || '',
                deptId: item.deptId || ''
              }
            })
            this.loading = false
          })
        } else if (this.type === 'customOrg') {
          this.getCustomBreachOrder({ customerName: query, ...this.extraParams }).then(res => {
            this.dataArr = res.map(item => {
              return {
                id: item.accountId,
                name: item.customerName
              }
            })
            this.loading = false
          })
        } else if (this.type === 'tagOrg') {
          this.getTagBreachOrder({ tagName: query, ...this.extraParams }).then(res => {
            this.dataArr = res.map(item => {
              return {
                id: item.tagId,
                name: item.tagName
              }
            })
            this.loading = false
          })
        } else if (this.type === 'tagBreach') {
          this.tagNameBreachOrder({ tagName: query, ...this.extraParams }).then(res => {
            this.dataArr = res.map(item => {
              return {
                id: item.tagId,
                name: item.tagName
              }
            })
            this.loading = false
          })
        } else if (this.type === 'notCustomOrg') {
          this.getNotCustomBreachOrder({ customerName: query, ...this.extraParams }).then(res => {
            this.dataArr = res.map(item => {
              return {
                id: item.accountId,
                name: item.customerName
              }
            })
            this.loading = false
          })
        } else if (this.type === 'oneCardMove') {
          if (query.length === 10) {
            this.searchCardProtocol({ originalPersonCard: query }).then(res => {
              this.dataArr = res.map(item => {
                return {
                  id: item,
                  name: item
                }
              })
              this.loading = false
            })
          } else {
            this.loading = false
          }
        } else if (this.type === 'protocolMove') {
          this.searchProtocolProtocol({ agreementCode: query, ...this.extraParams }).then(res => {
            this.dataArr = res.map(item => {
              return {
                id: item.agreementId,
                name: item.code
              }
            })
            this.loading = false
          })
        } else if (this.type === 'customMove') {
          this.searchCustomProtocol({ customerName: query, ...this.extraParams }).then(res => {
            this.dataArr = res.map(item => {
              return {
                id: item.id,
                name: item.customerName
              }
            })
            this.loading = false
          })
        } else if (this.type === 'customMoveAppoint') {
          this.searchCustomAppointProtocol({ customerName: query, ...this.extraParams }).then(res => {
            this.dataArr = res.map(item => {
              return {
                id: item.id,
                name: item.customerName
              }
            })
            this.loading = false
          })
        } else if (this.type === 'noIncludeFreight') {
          this.searchNoIncludeFreight({ areaName: query, ...this.extraParams }).then(res => {
            this.dataArr = res.map(item => {
              return {
                id: item.id,
                name: item.areaName
              }
            })
            this.loading = false
          })
        } else if (this.type === 'protocol') {
          this.getProtocols({ code: query, ...this.extraParams }).then(res => {
            this.dataArr = res.map(item => {
              return { ...item, id: item.id, name: item.code }
            })
            this.loading = false
          })
        } else if (this.type === 'year' || this.type === 'batch') { // 查询返优惠批次 or 年份
          let params = {}
          if (this.type === 'year') {
            params = { year: query, ...this.extraParams }
          } else {
            if (!this.extraParams.year) {
              this.$message.error('请选择产生年份')
              return
            }
            params = { batch: query, ...this.extraParams }
          }
          this.adjustAccountYearOrBatch(params).then(res => {
            this.dataArr = res.map(item => {
              if (this.type === 'year') {
                return { ...item, id: item.id, name: item.year }
              } else {
                return { ...item, id: item.id, name: item.batch }
              }
            })
            this.loading = false
          })
        } else if (this.type === 'usePolicyName') { // 返优惠规则
          this.getUsePolicyPage({ name: query, ...this.extraParams }).then(res => {
            this.dataArr = res.list.map(item => {
              return { ...item, id: item.id, name: item.name }
            })
            this.loading = false
          })
        } else if (this.type === 'orgIdsCustomer') {
          console.log('[ this.extraParams ] >', this.extraParams)
          this.getOrgIdsCustomer({ relationName: query, ...this.extraParams }).then(res => {
            this.dataArr = res.map(item => {
              return { ...item, id: item.relationID, name: item.relationName }
            })
            this.loading = false
          })
        } else {
          const params = {
            relationName: query,
            type: this.typeMap[this.type],
            ...this.extraParams
          }
          if (this.type === 'product') {
            params.takeAreaId = this.$attrs.takeAreaId
          }
          this.getNameInfo(params).then(res => {
            this.dataArr = res.map(item => {
              const obj = {
                id: item.relationID,
                name: item.relationName,
                code: item.itemCode,
                deptId: item.deptId,
                cartonNum: item.cartonNum,
                unit: item.itemUnit,
                memberTag: item.memberTag,
                unionCode: item.memberUnionCode,
                iCustomerId: item.iCustomerId, // 联合主客户
                iCustomerName: item.iCustomerName, // 联合主客户
                itemThirdCategory: item.itemThirdCategory, // 三级分类
                itemSecondCategory: item.itemSecondCategory,
                states: item.states,
                orgCodeLicenseName: item.orgCodeLicenseName
              }
              switch (params.type) {
                case 13:
                  obj.name = item.orderTemplateName
                  obj.list = item.basicGoodsPolicyDtoList
                  break
                case 14:
                  obj.unionCode = item.memberUnionCode
                  break
                case 181:
                  obj.unionCode = item.memberUnionCode // 是否联合客户
                  obj.purchasingQuantityMonth = item.purchasingQuantityMonth // 月订货量
                  obj.purchasingQuantityYear = item.purchasingQuantityYear // 年订货量
                  obj.khqdbq = item.khqdbq // 配置的优惠
                  break
                case 2: // 商品新增挂牌价
                  obj.newListingPrice = item.newListingPrice //  '挂牌价'
                  obj.newStrikePrice = item.newStrikePrice //  '执行价'
                  obj.itemTypeCode = item.itemTypeCode //  '普通or高端'
              }
              return obj
            })
            this.loading = false
          })
        }
      } else {
        this.dataArr = []
      }
    },
    initOption (val = this.currentValue) {
      if (this.isMultiple) {
        this.dataArr = val
      } else {
        this.dataArr = val ? [val] : []
      }
    }
  },
  watch: {
    value: {
      immediate: true,
      handler (newVal) {
        this.currentValue = newVal
        this.initOption()
      }
    }
  },
  mounted () {
  }
}
</script>

<style lang="scss" scoped>
.search-keyword {
  text-align: center;
  padding: 3px 0;
  color: #ccc;
  font-size: 13px;
}
</style>
